import React, { useRef, useState } from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import { useApp } from "../../AppProvider";
import { Draggable } from "react-beautiful-dnd";
import Avatar from '@mui/material/Avatar';
import EditBookedAppointment from '../../Components/Appointment/EditBookedAppointment';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';

const Card = ({ task, index }) => {
  const editIconRef = useRef();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const { setSelectedPatient, cardDropDownCondition, setSelectedAppointment, stringAvatar, stringToColor } = useApp();

  // const navigate = useNavigate();


  const handleClick = (event) => {
    if (task && task.patientId) {
      setSelectedPatient(task.patientId);
      // console.log("Hanle Click Task", task)
      setSelectedAppointment(task.id);
      // navigate('/DashboardDashboardNavigation/history');
    }
  };

  function getEventColor(eventType) {
    switch (eventType) {
      case "New":
        return "new-bg";
      case "Follow-up Consultation":
        return "regular-bg";
      case "Critical":
        return "critical-bg";
      case "Normal Consultation":
        return "published-bg";
      default:
        return "";
    }
  }

  function getTextColor(eventType) {
    switch (eventType) {
      case "New":
        return "new";
      case "Follow-up Consultation":
        return "regular";
      case "Critical":
        return "critical";
      case "Normal Consultation":
        return "published";
      default:
        return "";
    }
  }

  function getInvoiceStatusStyle(status) {
    switch (status) {
      case "Paid":           return { background: "#dcfce7", color: "#166534" };
      case "Partially Paid": return { background: "#dbeafe", color: "#1e40af" };
      case "Pending":        return { background: "#fef3c7", color: "#92400e" };
      case "Overdue":        return { background: "#fee2e2", color: "#991b1b" };
      case "Cancelled":      return { background: "#f3f4f6", color: "#6b7280" };
      default:               return null;
    }
  }

  const filterCards = () => {
    if (cardDropDownCondition === "") {
      return true;
    } else {
      return task.tag === cardDropDownCondition;
    }
  };

  const handleEditAppointment = (event) => {
    event.stopPropagation(); // Prevents click event from bubbling up to parent
    event.preventDefault();
    setEditModalOpen(true);
  };

  return (
    <>
      <Draggable draggableId={task.id} index={index}>
        {(provided, snapshot) => (
          <div
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              handleClick()
            }}
            style={{ pointerEvents: 'auto' }}>
            {filterCards() && (
              <Link
                to="/DashboardDashboardNavigation/history"
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                className="card-drag"
                style={{
                  userSelect: "none",
                  textDecoration: "none",
                  margin: "0 0 8px 0",
                  background: snapshot.isDragging ? "lightgreen" : "white",
                  ...provided.draggableProps.style
                }}
              >
                <div className="card-main_box">
                  <div className="edit-icon-container"
                    onClick={(event) => { handleEditAppointment(event); }}
                    ref={editIconRef}>
                    <ModeEditOutlineOutlinedIcon className="edit-icons" />
                  </div>
                  <div className="card-section-1">
                    <div>
                      <Avatar sx={{ width: { md: 40, lg: 50, xl: 50 }, height: { md: 40, lg: 50, xl: 50 }, bgcolor: task.img ? 'transparent' : stringToColor(task.content) }}
                        alt={task.content}
                        src={task.img} >
                        {!task.img && stringAvatar(`${task.content}`).children}
                      </Avatar>
                    </div>
                    <p>{task.content}</p>
                  </div>
                  <div className="card-section-2">
                    <div className={`button-status ${getEventColor(task.tag)} ${getTextColor(task.tag)}`}>
                      {task.tag}
                    </div>
                    <span>{task.time}</span>
                  </div>
                  {task.invoiceStatus && getInvoiceStatusStyle(task.invoiceStatus) && (
                    <div className="card-section-3">
                      <span className="invoice-status-pill" style={getInvoiceStatusStyle(task.invoiceStatus)}>
                        {task.invoiceStatus}
                      </span>
                    </div>
                  )}
                </div>
              </Link>
            )}
          </div>
        )}
      </Draggable>
      <div className="container-appointment_select-slotPage">
        {editModalOpen && (
          <EditBookedAppointment setEditModalOpen={setEditModalOpen} task={task} />
        )}
      </div>
    </>
  );
};

export default Card;
